import React, { useState } from "react";
import "./agency.css";

/* ================= DIGITAL SERVICES ================= */
const services = [
  {
    title: "Website Development – ₹14,999",
    icon: "💻",
    desc: "Professional website that builds trust and converts visitors into paying customers. Perfect for businesses who want online presence, branding and 24/7 enquiries.",
  },
  {
    title: "SEO Services – ₹12,999/month",
    icon: "🚀",
    desc: "Get ranked on Google and bring free organic traffic every month. Helps customers find you before competitors.",
  },
  {
    title: "Social Media Management – ₹9,999/month",
    icon: "📱",
    desc: "Daily posts, reels and branding to build authority and engagement.",
  },
  {
    title: "Facebook, Instagram & Google Ads – ₹15,000/month",
    icon: "🎯",
    desc: "Instant leads and sales through paid advertising.",
  },
  {
    title: "Complete Growth Combo – ₹29,999/month",
    icon: "📈",
    desc: "All-in-one package including website, SEO, social media and ads.",
  },
];

export default function Agency() {
  // ✅ TWO DIFFERENT POPUPS
  const [openConsultation, setOpenConsultation] = useState(false);
  const [openService, setOpenService] = useState(false);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    service: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ WhatsApp send
  const sendToWhatsApp = () => {
    let newErrors = {};

    if (!form.name.trim()) newErrors.name = "Name is required";
    if (!form.phone.trim()) newErrors.phone = "Phone is required";
    if (!form.service.trim()) newErrors.service = "Service is required";

    if (form.phone && form.phone.length < 10) {
      newErrors.phone = "Enter valid phone number";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const message = `Hello, I am interested.

Name: ${form.name}
Phone: ${form.phone}
Service: ${form.service}`;

    const phoneNumber = "919967956503";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  return (
    <div className="agency-page">
      {/* HERO */}
      <section className="agency-hero">
        <h1>We Grow Your Business Digitally</h1>
        <p>Result driven digital marketing solutions to boost your brand.</p>

        {/* 🔥 HERO POPUP BUTTON */}
        <button
          className="agency-cta"
          onClick={() => {
            setForm({ name: "", phone: "", service: "Free Consultation" });
            setOpenConsultation(true);
          }}
        >
          Get Free Consultation
        </button>
      </section>

      {/* ================= DIGITAL MARKETING ================= */}
      <section className="agency-services">
        <h2>Digital Marketing Services</h2>

        <div className="services-grid">
          {services.map((service, i) => (
            <div className="service-card" key={i}>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>

              {/* 🔥 SERVICE POPUP BUTTON */}
              <button
                className="agency-cta small"
                onClick={() => {
                  setForm({ name: "", phone: "", service: service.title });
                  setOpenService(true);
                }}
              >
                Choose Plan
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="agency-bottom">
        <h2>Ready to scale your business?</h2>
      </section>

      {/* ===================================================== */}
      {/* ⭐ CONSULTATION MODAL */}
      {/* ===================================================== */}
      {openConsultation && (
        <div
          className="agency-modal-overlay"
          onClick={() => setOpenConsultation(false)}
        >
          <div className="agency-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setOpenConsultation(false)}
            >
              ✕
            </button>

            <h3>Free Consultation</h3>

            <input
              type="text"
              placeholder="Your Name"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
            {errors.name && <p className="error-text">{errors.name}</p>}

            <input
              type="tel"
              placeholder="Phone Number"
              name="phone"
              value={form.phone}
              onChange={handleChange}
            />
            {errors.phone && <p className="error-text">{errors.phone}</p>}

            <input value={form.service} readOnly />

            <button className="agency-cta" onClick={sendToWhatsApp}>
              Request Call
            </button>
          </div>
        </div>
      )}

      {/* ===================================================== */}
      {/* ⭐ SERVICE MODAL */}
      {/* ===================================================== */}
      {openService && (
        <div
          className="agency-modal-overlay"
          onClick={() => setOpenService(false)}
        >
          <div className="agency-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setOpenService(false)}
            >
              ✕
            </button>

            <h3>Confirm Your Interest</h3>

            <input
              type="text"
              placeholder="Your Name"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
            {errors.name && <p className="error-text">{errors.name}</p>}

            <input
              type="tel"
              placeholder="Phone Number"
              name="phone"
              value={form.phone}
              onChange={handleChange}
            />
            {errors.phone && <p className="error-text">{errors.phone}</p>}

            <input value={form.service} readOnly />
            {errors.service && <p className="error-text">{errors.service}</p>}

            <button className="agency-cta" onClick={sendToWhatsApp}>
              Continue to WhatsApp
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
